import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { SubmitQQAgentFeedbackParams } from 'types/agents/QuickQuoteAgent';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

const DEFAULT_ERROR_MESSAGE = "Couldn't save your feedback. Try again.";

// Records a rep's thumbs up/down (and optional note) on a written-rules agent run.
export async function submitQQAgentFeedback({
  invocationId,
  rating,
  note,
}: SubmitQQAgentFeedbackParams): Promise<Result<null, ApiError>> {
  try {
    const trimmedNote = note?.trim();
    await axios.post(
      `/agent/quick-quote/invocations/${invocationId}/feedback`,
      {
        rating,
        ...(trimmedNote ? { note: trimmedNote } : {}),
      }
    );

    return ok(null);
  } catch (error) {
    captureException(error, { functionName: 'submitQQAgentFeedback' });

    if (!isAxiosError(error)) {
      return err({ message: DEFAULT_ERROR_MESSAGE });
    }

    if (error.response?.status === 401) {
      throw error;
    }

    return err({
      message: error.response?.data?.message || DEFAULT_ERROR_MESSAGE,
    });
  }
}
